import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireImage} from '../umpire-image';

export interface UmpireComponentAdvertisement
  extends UmpireComponent<UmpireComponentTypeEnum.ADVERTISEMENT> {
  external_url: string;
  image: UmpireImage;
}
